"use client";
import React, { useState, useEffect } from "react";
import logo from "../../../../public/Images/header-logo.svg";
import facebook from "../../../../public/Images/footer/facebook.png";
import instagram from "../../../../public/Images/footer/instagram.png";
import x from "../../../../public/Images/footer/x.png";
import linkedin from "../../../../public/Images/footer/linkedin.png";
import mail from "../../../../public/Images/footer/mail.png";
import pin from "../../../../public/Images/footer/pin.png";
import "../../globals.css";
import "./footer.style.css";
import Image from "next/image";
import { GetSettings } from "@/action/action";
import Link from "next/link";

const Footer = () => {
  const [data, setData] = useState();
  useEffect(() => {
    GetSettings({
      callback: (res) => {
        if (res) {
          setData(res);
        }
      },
    });
  }, []);

  if (!data) {
    return <div />;
  }
  return (
    <>
      <div className="footerContainer" id="footer">
        <div className="info">
          <Image
            className="footerLogo"
            src={logo}
            width={100}
            height={50}
            alt="logo"
          />
          <p
            className="footerDescription"
            dangerouslySetInnerHTML={{ __html: data?.description }}
          />
          <div className="logosContainer">
            <Link target="_blank" href={data?.fb_link}>
              <Image
                src={facebook}
                className="socialLogo"
                width={35}
                height={35}
                alt="facebook logo"
              />
            </Link>
            <Link target="_blank" href={data?.x_link}>
              <Image
                src={x}
                className="socialLogo"
                width={35}
                height={35}
                alt="x logo"
              ></Image>
            </Link>
            <Link target="_blank" href={data?.linkedin_link}>
              <Image
                src={linkedin}
                className="socialLogo"
                width={40}
                height={40}
                alt="linkedin logo"
              ></Image>
            </Link>
            <Link target="_blank" href={data?.insta_link}>
              <Image
                src={instagram}
                className="socialLogo"
                width={40}
                height={40}
                alt="instagram logo"
              ></Image>
            </Link>
          </div>
        </div>
        <div className="menuItems">
          <div className="navigation">
            <h1>Explore</h1>
            <ul>
              <li>
                <Link href="/home#banner">Home</Link>
              </li>
              <li>
                <Link href="/about_us">About us</Link>
              </li>
              <li>
                <Link href="/projects">Portfolio</Link>
              </li>
              <li>
                <Link href="/blog">Blog</Link>
              </li>
              <li>
                <Link href="/introCallPage">Intro call</Link>
              </li>
            </ul>
          </div>
          <div className="licence">
            <h1>Legal</h1>
            <ul>
              <li>
                <Link href="/policy?policy=terms-and-conditions">
                  Terms and conditions
                </Link>
              </li>
              <li>
                <Link href="/policy?policy=privacy-policy">Privacy policy</Link>
              </li>
            </ul>
          </div>
          <div className="contact">
            <h1>Contact</h1>
            <ul>
              <li>
                <Link href={`mailto:${data?.email}`} className="contact-info">
                  <Image
                    src={mail}
                    className="contactLogos"
                    width={25}
                    height={25}
                    alt=""
                  />
                  {data?.email}
                </Link>
              </li>
              <li>
                <span className="contact-info location">
                  <div className="location-logo">
                    <Image
                      src={pin}
                      className="contactLogos"
                      width={25}
                      height={25}
                      alt=""
                    />
                  </div>
                  {data?.location}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};
export default Footer;
